import ResizeObserver from 'resize-observer-polyfill';
import aspect from '../common/aspect';

const ro = new ResizeObserver(entries => {
  entries.forEach(({ target, contentRect }) => {
    target.resize && target.resize(contentRect);
  });
});

// TODO bug target.prototype

/*
 * provide feature to call resize function of element when element size changed.
 *
 * */
export default function autoResize() {
  return function decorator(target) {
    aspect(target.prototype, 'connectedCallback', origin => {
      return function () {
        ro.observe(this);
        origin.apply(this);
      };
    });

    aspect(target.prototype, 'disconnectedCallback', origin => {
      return function () {
        ro.unobserve(this);
        origin.apply(this);
      };
    });
  };
}
